// extracted by mini-css-extract-plugin
module.exports = {"LineItemHeader":"LineItemHeader_LineItemHeader__1KkNx","userIcon":"LineItemHeader_userIcon__r5g7v","name":"LineItemHeader_name__AOE9N","mdn":"LineItemHeader_mdn__2Xsow"};